import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { GenderChangeForm } from './GenderChangeForm'

/**
 * Gender change is when a participant has changed gender and the altered gender needs to be applied.
 *
 * It can also be used to just set the gender on a person. It is possible to choose unknown, if a persons gender is in fact unknown.
 *
 * @links
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api:openapi legalentity/com__GenderChangeCommandData, APIs for Gender change@
 */
export function GenderChangeCommand(props: ActionButtonProps) {
  const translate = useTranslate()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const actions = useHook('mutators.crm.useChangeGenderActions')({
    tenantId,
    personId: ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.GenderChangeCommandData"
      title={translate('genderChange.button')}
      {...props}
      commandDataForm={GenderChangeForm}
      submit={submit}
    />
  )
}
